<template>
  <div class="main" v-loading="loading">
    <div class="tab_content">
      <div
        class="tab_content_each"
        v-for="(item, index) in options"
        :key="index"
        @click="selectType(item)"
        :class="{ active: item.value == type }"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-if="type == 1">
      <div>
        <div class="list_div" v-for="(item, index) in list" :key="index">
          <div class="div_box">
            <div style="display: flex; align-items: center">
              <i class="iconfont icon-wenjianleixing-biaozhuntu-PDFwendang"></i>
              <p class="bb_name">{{ item.name }}</p>
            </div>
            <div style="display: flex; align-items: center">
              <el-button
                type="success"
                size="small"
                plain
                @click="cwbbDownload(item)"
                :loading="item.downLoading"
                icon="Download"
                >下载</el-button
              >
              <el-button
                type="primary"
                size="small"
                plain
                @click="sendCwbb(item)"
                icon="Promotion"
                :loading="item.sendLoading"
                >发送</el-button
              >
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div v-if="type == 2">
      <div class="list_div" v-for="(item, index) in taxList" :key="index">
        <div class="div_box" v-if="item.tableName != 'gs_cwbb'">
          <div style="display: flex; align-items: center">
            <i class="iconfont icon-wenjianleixing-biaozhuntu-PDFwendang"></i>
            <p class="bb_name">{{ $tableNameFilter(item.tableName) }}</p>
          </div>
          <div style="display: flex; align-items: center">
            <el-button
              type="success"
              size="small"
              plain
              @click="taxDownload(item)"
              :loading="item.downLoading"
              icon="Download"
              >下载</el-button
            >
            <el-button
              type="primary"
              size="small"
              plain
              @click="sendSwbb(item)"
              :loading="item.sendLoading"
              icon="Promotion"
              >发送</el-button
            >
          </div>
        </div>
        <div class="line" v-if="item.tableName != 'gs_cwbb'"></div>
      </div>
    </div>
    <div v-if="type == 3">
      <div
        class="list_div"
        v-for="(item, index) in accountOptions"
        :key="index"
      >
        <div class="div_box">
          <div style="display: flex; align-items: center">
            <i class="iconfont icon-wenjianleixing-biaozhuntu-PDFwendang"></i>
            <p class="bb_name">{{ item.name }}</p>
          </div>
          <div style="display: flex; align-items: center">
            <el-button
              type="success"
              size="small"
              plain
              @click="taxDownload(item)"
              :loading="item.downLoading"
              icon="Download"
              >下载</el-button
            >
            <el-button
              type="primary"
              size="small"
              plain
              @click="sendSwbb(item)"
              :loading="item.sendLoading"
              icon="Promotion"
              >发送</el-button
            >
          </div>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue"
import { qywxTaxList, qywxPrintReport } from "@/api/home"
import { ElMessage } from "element-plus"
const props = defineProps({
  period: { type: String, default: "" },
  comInfo: { type: Object, default: () => {} },
  cKey: { type: Number, default: 0 },
})
const comId = ref(null)
const type = ref(3)
const period = ref()
const taxList = ref([])
const loading = ref(false)
const options = ref([
  { label: "账簿", value: 3 },
  { label: "财务报表", value: 1 },
  { label: "税务报表", value: 2 },
])
const accountOptions = ref([
  {
    tableName: "book_subject_balance",
    name: "科目余额表",
  },
  {
    tableName: "book_all_voucher",
    name: "凭证汇总",
  },
  {
    tableName: "book_all_account",
    name: "总账",
  },
  {
    tableName: "book_detail_account",
    name: "明细账",
  },
])
const list = computed(() => {
  let arr = [
    {
      name: "资产负债表",
      tableName: "kj_zcfz",
      itemName: "",
    },
    {
      name: "利润表(季报)",
      tableName: "kj_lrb_q",
      itemName: "",
    },
    {
      name: "利润表(月报)",
      tableName: "kj_lrb_m",
      itemName: "month",
    },
    {
      name: "利润统计表",
      tableName: "kj_lrb",
      itemName: "year",
    },
    {
      name: "现金流量表(月报)",
      tableName: "kj_xjllb_m",
      itemName: "month",
    },
    {
      name: "现金流量表(季报)",
      tableName: "kj_xjllb_q",
      itemName: "",
    },
  ]
  let arr1 = [
    //民办非
    {
      name: "资产负债表",
      tableName: "kj_zcfz",
      itemName: "",
    },
    {
      name: "业务活动表(月报)",
      tableName: "kj_lrb",
      itemName: "month",
    },
    {
      name: "业务活动表(季报)",
      tableName: "kj_lrb",
      itemName: "",
    },
  ]
  let arr2 = [
    //农村合作社
    {
      name: "资产负债表",
      tableName: "kj_zcfz",
      itemName: "",
    },
    {
      name: "盈余及盈余分配表",
      tableName: "kj_lrb",
      itemName: "",
    },
    {
      name: "成员权益变动表",
      tableName: "kj_lrb",
      itemName: "cy",
    },
  ]
  if (comForm.value.accountSystem == "民办非") {
    return arr1
  } else if (comForm.value.accountSystem == "农业合作社") {
    return arr2
  } else {
    return arr
  }
})
const comForm = ref({})
const getList = () => {
  if (type.value == 2) {
    loading.value = true
    qywxTaxList({
      comId: comId.value,
      period: period.value,
    }).then((res) => {
      loading.value = false
      if (res.data.msg == "success") {
        taxList.value = res.data.data.list
      }
    })
  }
}
//下载财务报表
const cwbbDownload = (item) => {
  item.downLoading = true
  let params = {
    comIds: [comId.value],
    period: period.value,
    bookNames: [item.tableName],
    itemName: item.itemName,
    merge: 1,
    from: "kjbb",
    mediaId: false,
  }
  qywxPrintReport(params).then((res) => {
    item.downLoading = false
    if (res.data.msg == "success") {
      window.open(res.data.data.url)
    }
  })
}
//发送财务报表
const sendCwbb = (item) => {
  item.sendLoading = true
  let params = {
    comIds: [comId.value],
    period: period.value,
    bookNames: [item.tableName],
    itemName: item.itemName,
    merge: 1,
    from: "kjbb",
    mediaId: true,
  }
  qywxPrintReport(params).then((res) => {
    item.sendLoading = false
    if (res.data.msg == "success") {
      wx.invoke(
        "sendChatMessage",
        {
          msgtype: "file", //消息类型，必填
          file: {
            mediaid: res.data.data.mediaId, //文件的素材id
          },
        },
        function (res) {
          if (res.err_msg == "sendChatMessage:ok") {
            ElMessage.success("发送成功")
          }
        },
      )
    }
  })
}
///下载税务报表
const taxDownload = (item) => {
  item.downLoading = true
  let param = {
    comIds: [comId.value],
    period: period.value,
    bookNames: [item.tableName],
    mediaId: false,
  }
  qywxPrintReport(param).then((res) => {
    item.downLoading = false
    if (res.data.msg == "success") {
      window.open(res.data.data.url)
    }
  })
}
//发送税务报表
const sendSwbb = (item) => {
  item.sendLoading = true
  let param = {
    comIds: [comId.value],
    period: period.value,
    bookNames: [item.tableName],
    mediaId: true,
  }
  qywxPrintReport(param).then((res) => {
    item.sendLoading = false
    if (res.data.msg == "success") {
      wx.invoke(
        "sendChatMessage",
        {
          msgtype: "file", //消息类型，必填
          file: {
            mediaid: res.data.data.mediaId, //文件的素材id
          },
        },
        function (res) {
          if (res.err_msg == "sendChatMessage:ok") {
            ElMessage.success("发送成功")
          }
        },
      )
    }
  })
}
const selectType = (item) => {
  type.value = item.value
  getList()
}
watch(
  () => [props.period, props.comInfo, props.cKey],
  (newVal) => {
    period.value = newVal[0]
    comId.value = newVal[1].id
    comForm.value = newVal[1]
    if (comId.value) {
      getList()
    }
  },
  { immediate: true },
)
</script>

<style scoped lang="scss">
.tab_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 5px;
  background-color: #fff;
  font-size: 14px;

  .tab_content_each {
    flex: 1;
    text-align: center;
    padding: 3px 0;
    border: 1px solid #efefef;
    border-radius: 4px;
    cursor: pointer;
  }

  .active {
    color: $color-main;
  }
}

.date {
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.list_div {
  display: flex;
  flex-direction: column;

  .div_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
    margin-left: 10px;
    margin-right: 10px;

    .bb_name {
      margin-left: 6px;
      font-size: 14px;
    }

    .button_send {
      border: 1px solid #3c6ff2;
      width: 60px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      color: #3c6ff2;
      border-radius: 3px;
      font-weight: 500;
    }

    .button_download {
      border: 1px solid #bebdbd;
      width: 60px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #b3b1b1;
      font-size: 13px;
      border-radius: 3px;
      font-weight: 500;
      margin-right: 10px;
    }
  }
}

.baobiao {
  font-size: 25px;
}

.ask {
  font-size: 14px;
  margin-left: 10px;
}

.eyes {
  font-size: 14px;
  margin-right: 10px;
}

.line {
  width: 100%;
  height: 1px;
  background-color: #efefef;
  margin-top: 15px;
}

.top {
  text-align: center;
  padding: 10px 0;
  background-color: #fff;
}

.el-button + .el-button {
  margin-left: 5px;
}

.el-button--small {
  padding: 5px 6px;
}
</style>
